import { FIELDS } from "lib"

export const REJECTIONCAUSE_TABLE_COLUMNS = [
    { id: FIELDS.rejectionCauseCode.key, label: FIELDS.rejectionCauseCode.name },
    { id: FIELDS.name.key, label: FIELDS.name.name },
    { id: FIELDS.description.key, label: FIELDS.description.name },
    { id: FIELDS.active.key, label: FIELDS.state.name },
]